/**
 * ActivityTrackerProvider
 *
 * Invisible component that sits inside the Router tree and calls
 * useActivityTracker on every render. Must be inside the tRPC provider.
 */
import { useAuth } from "@/utils/useAuth";
import { useActivityTracker } from "@/hooks/useActivityTracker";

export function ActivityTrackerProvider() {
  const { isAuthenticated } = useAuth();
  useActivityTracker(isAuthenticated);
  return null;
}
